import React, {useState} from "react";
import { Button, Card, Alert } from "react-bootstrap";
import { useAuth } from 'contexts/authContext'
import { Link , useHistory  } from 'react-router-dom'


function Home(){

    const [error,setError] = useState("")
    const {currentUser , logout} = useAuth()
    const history = useHistory()

    async function handleLogout(){ 

        setError('')

        try{
            await logout()
            history.pushState('/login')

        }catch{
            setError('failed to logout')
        }

    }


    return(
    <>

        <Card>
            <Card.Body>

            <h2 className="text-center mb-4">Transport Manager Profile</h2>
            {error && <Alert variant="danger">{error}</Alert>}
            <strong>Email: </strong> {currentUser.email}
            <Link to="/Dashboard" className="btn btn-primary w-100 mt-3">
            Go to Dashboard
          </Link>


        </Card.Body>
        </Card>

        <div className="w-100 text-center mt-2">
        <Button variant="link" onClick={handleLogout}> Logout </Button>
      </div>





    </>
    )
}

export default Home


